export const SUPPLIER_QUESTIONNAIRES = {
  TITLE: 'Cuestionarios',
  UPLOAD_BUTTON: 'Subir Cuestionario',
  EMPTY_STATE: {
    TITLE: 'Aún no hay cuestionarios',
    DESCRIPTION: 'Sube tu primer cuestionario de proveedor para comenzar..',
  },
  FORM: {
    QUESTIONNAIRE_NAME_LABEL: 'Nombre del Cuestionario',
    QUESTIONNAIRE_NAME_PLACEHOLDER: 'Ingresa un nombre para este cuestionario',
  },
  ACTIONS: {
    UPLOAD: 'Subir',
    UPLOAD_QUESTIONNAIRE: 'Subir Cuestionario',
    UPLOADING: 'Subiendo...',
    MARK_COMPLETED: 'Marcar como completado',
    DOWNLOAD_PACKAGE: 'Descargar paquete de evidencias',
    CANCEL: 'Cancelar',
  },
  DIALOG: {
    TITLE: 'Subir Cuestionario',
    DESCRIPTION: 'Sube un archivo de cuestionario (Excel, Word, PDF u OpenDocument) para procesarlo.',
  },
  FILE_DROP_ZONE: {
    DRAG_AND_DROP: 'Arrastra y suelta tu archivo aquí, o',
    SELECT_FILE: 'Seleccionar Archivo',
    FILE_TYPE_HINT: 'Excel, Word, PDF u OpenDocument',
  },
  ROW: {
    PROCESSING: 'Procesando...',
    QUESTIONS_SUFFIX: 'preguntas',
  },
  TOOLTIPS: {
    DOWNLOAD_ORIGINAL: 'Descargar Original',
    DOWNLOAD_RESPONSE: 'Descargar Respuesta',
    PACKAGE_PREPARING: 'El paquete de evidencias aún se está preparando',
    DELETE: 'Eliminar',
  },
  STATUS: {
    SUBMITTED: 'Enviado',
    IN_PROGRESS: 'En Progreso',
    READY: 'Listo',
    COMPLETED: 'Completado',
  },
  SUMMARY: {
    QUESTIONS_LABEL: 'Preguntas',
    ANSWERED: 'respondidas',
    PENDING: 'pendientes',
    QUESTIONNAIRE: 'cuestionario',
    QUESTIONNAIRES: 'cuestionarios',
    READY: 'listos',
    IN_PROGRESS: 'en progreso',
    SUBMITTED: 'enviados',
  },
  MESSAGES: {
    UPLOAD_SUCCESS: 'Cuestionario subido correctamente',
    DELETE_SUCCESS: 'Cuestionario eliminado correctamente',
    FILE_NOT_FOUND: 'Este archivo ya no está disponible',
    ALREADY_COMPLETED: 'Este cuestionario está completado y ya no se puede modificar.',
    PACKAGE_NOT_READY: 'El paquete aún no está listo.',
    COMPLETE_SUCCESS: 'Cuestionario marcado como completado',
    CANNOT_COMPLETE: 'Este cuestionario aún no se puede completar: su paquete no está listo.',
  },
  COMPLETE_DIALOG: {
    TITLE: '¿Marcar el cuestionario como completado?',
    BODY: '"{name}" se marcará como completado y su paquete de evidencias estará disponible. Esta acción no se puede deshacer.',
  },
  DELETE_DIALOG: {
    TITLE: 'Eliminar Cuestionario',
    QUESTION: '¿Estás seguro de que deseas eliminar',
    WARNING: 'Esta acción no se puede deshacer.',
  },
} as const
